import { Workout } from 'app/@core/interfaces/common/CalorieFriend/workout';
import { WorkoutDetail } from './../../@core/interfaces/common/CalorieFriend/workout';
import { ActivatedRoute } from '@angular/router';
import {
  WorkoutMode,
  WorkoutService,
} from '../../@core/backend/common/services/CalorieFriend/workout.service';
import { IComponentCanDeactivate } from '../../@auth/guards/changes.guard';
import { Component, OnInit } from '@angular/core';
import {
  differenceInHours,
  differenceInMinutes,
  differenceInSeconds,
} from 'date-fns';
import { Utility } from 'app/@core/utils/utility';
import { PatientsService } from 'app/@core/backend/common/services/CalorieFriend/patients.service';
import { Patient } from 'app/@core/interfaces/common/CalorieFriend/patients';

type LogDetail = {
  [exNo: string]: WorkoutDetail[];
};

@Component({
  selector: 'patient-fitness-workout-logs-view',
  templateUrl: './patient-fitness-workout-logs-view.component.html',
  styleUrls: ['./patient-fitness-workout-logs-view.component.scss'],
})
export class PatientFitnessWorkoutLogsViewComponent implements OnInit {
  workoutId: number;
  workoutDetails: WorkoutDetail[];
  workout: Workout;
  logDetails: LogDetail;
  patient: Patient;

  constructor(
    private workoutService: WorkoutService,
    private activatedRoute: ActivatedRoute,

    private patientsService: PatientsService
  ) {}

  ngOnInit(): void {
    this.workoutId = Number(
      this.activatedRoute.snapshot.paramMap.get('WorkoutId')
    );
    this.initialize();
  }

  async initialize() {
    const token =
      this.activatedRoute.snapshot.paramMap.get('NotificationToken');
    this.patient = await this.patientsService
      .get(null, token)
      .toPromise<Patient>();

    this.workoutDetails = await this.workoutService.getDetailsAll(this.workoutId);
    this.workout = await this.workoutService.getWorkout(this.workoutId);
    let blockIndex = -1,
      itemIndex = 0;
    const details: LogDetail = {};
    for (let i = 0; i < this.workoutDetails.length; i++) {
      const prevW = i > 0 && this.workoutDetails[i - 1];
      const w = this.workoutDetails[i];
      if (w.blockId != prevW?.blockId) {
        blockIndex++;
        itemIndex = 0;
      }
      if (prevW?.isCircuitSetNumber != w.isCircuitSetNumber) {
        itemIndex = 0;
      }
      ++itemIndex;
      let exNo = `${String.fromCharCode(0x41 + blockIndex)}${itemIndex}`;

      if (w.isCircuitSetNumber == 0 || !details[exNo]) {
        details[exNo] = [];
      }
      details[exNo].push(w);
    }

    console.log(details);

    this.logDetails = details;
  }

  get workoutStart() {
    return new Date(this.workout?.startDateTime + 'Z').toLocaleString();
  }
  get workoutDuration() {
    if (!this.workout) return 0;
    return Utility.getTimeDiffDisplayString(
      this.workout?.startDateTime,
      this.workout?.endDateTime,
      true
    );
  }

  get logDetailKeys() {
    if (!this.logDetails) return [];
    return Object.keys(this.logDetails);
  }
}
